export default function BrowserAgentDiagnosticPage() {
  return (
    <main className="mx-auto max-w-xl space-y-4 px-6 py-12 text-stone-800">
      <h1 className="text-2xl font-semibold">浏览器连接检查页面</h1>
      <p>插件读取下方标记后会关闭它为本次检查创建的页面。此页面没有账号信息，也不会调用模型。</p>
      <p className="rounded-lg border p-4 font-mono" data-browser-agent-diagnostic="BROWSER_AGENT_DIAGNOSTIC_OK">
        BROWSER_AGENT_DIAGNOSTIC_OK
      </p>
    </main>
  );
}
